import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserContext from "../context/User";

function PrivateRoute({ children }) {
  const { isLoggedIn } = useContext(UserContext);
  const location = useLocation();

  // The redirect target must go in `search`, not `pathname`. React Router v6
  // throws on a '?' inside a manually specified `to.pathname`, and a throw in
  // render with no boundary above it unmounts the whole tree — a blank white
  // page on whatever protected route the user landed on (e.g. the order detail
  // page they are sent back to after paying).
  if (!isLoggedIn)
    return (
      <Navigate
        to={{
          pathname: "/login",
          search: `?redirect=${encodeURIComponent(
            location.pathname + location.search
          )}`,
        }}
        state={{ from: location.pathname + location.search }}
      />
    );
  return children;
}

export default PrivateRoute;
